export enum Dropdown {
  Account = 'Account',
  Garage = 'Garage',
}
